import CourseController from '../diagrams/course.controller';

class ScqDiagramController extends CourseController {

  constructor(courseService, diagramService, $translate, $timeout, $scope) {
    'ngInject';

    super(courseService, diagramService, $translate, $scope);

    this.$timeout = $timeout;
    this.paperAnswer = false;
    this.studentAnswerRows = 23;
    this.expandedBgHeight = '0px'
    this.isSCQ = true
    this.model = {
      s: '',
      c: '',
      q: '',
      a: '',
      paper: ''
    }
  }

  $postLink() {
    this.diagramId = this.data.id;
    this.hideTaskTitle = this.data.hideTaskTitle;
  }

  showPaperAnswer (diagramId) {
    this.paperAnswer = true
    this.studentAnswerRows = 4

    const textField = $(document.querySelector(`#${diagramId || this.diagramId} .student-paper-answer__field`))
    const inputText = textField.val()
    const inputWidth = textField.css('width')
    this.inputLineHeight = parseInt(textField.css('line-height').slice(0, -2))

    const div = document.querySelector(`#${diagramId || this.diagramId} #check-lines`)
    const textarea = document.createElement('textarea')
    textarea.classList.add('student-paper-answer__field')
    textarea.value = inputText
    textarea.style.width = inputWidth

    div.appendChild(textarea)
    const scrollHeight = textarea.scrollHeight

    div.parentNode.removeChild(div);

    this.userAnswerRowsCount = Math.floor(scrollHeight / this.inputLineHeight)

    this.isUserAnswerBigger = this.userAnswerRowsCount > 6
  }

  expandUserAnswer(diagramId) {
    this.studentAnswerRows = this.userAnswerRowsCount

    const scqDiagram = $(`#${diagramId || this.diagramId}`)
    const diagramHeight = scqDiagram.height()

    scqDiagram.removeClass('growLayout')
    const growHeight = this.userAnswerRowsCount * this.inputLineHeight + 16
    scqDiagram.height(diagramHeight + growHeight)
    this.isUserAnswerExpanded = true
    this.expandedBgHeight = growHeight + 'px'
    //  move buttons
    const nextButton = $(document.querySelector(`#${diagramId || this.diagramId} #next`))
    nextButton.css({top: diagramHeight + growHeight - 520 + 'px'})
  }

  showUserAnswear(block) {
    if (this.diagramComplete) {
      block.model = block.userAnswer;
    }
  }

  hideUserAnswear(block) {
    if (this.diagramComplete) {
      block.model = block.answer;
    }
  }

  submit() {
    this.data.blocks.forEach(block => {
      this.model[block.modelName] = block.model
    })
    this.amountCorrectAnswers = this.data.correctAnswers
    this.submitCount++;
    this.courseService.play('buttonClick');
    if (this.hideTaskTitle) {
      this.hideTaskTitle = false;
    } else {
      let time = 500;
      for (let block of this.data.blocks) {
        block.userAnswer = block.model;
        this.$timeout(() => block.model = block.answer, time);
        time += 500;
      }
    }
    this.finishExercise();
    this.diagramComplete = true;
  }

  showUserAnswers() {

  }

  isNeedToShowTaskTitle() {
    return this.showTaskTitle;
  }

}

export default ScqDiagramController;



// WEBPACK FOOTER //
// ./client/app/components/scq-diagram/scq-diagram.controller.js